let toastHandler = null;

export const setToastHandler = (handler) => {
  toastHandler = handler;
};

export const showGlobalToast = (message, options = {}) => {
  if (toastHandler) {
    toastHandler(message, options);
  }
};
